import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    ElementRef
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    ProfileServiceProxy,
    VerifySmsCodeInputDto
} from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'smsVerificationModal',
    templateUrl: './sms-verification-modal.component.html'
})
export class SmsVerificationModalComponent extends AppComponentBase {
    @ViewChild('nameInput') nameInput: ElementRef;
    @ViewChild('smsVerificationModal') modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    public active = false;
    public saving = false;
    public verifyCode: VerifySmsCodeInputDto = new VerifySmsCodeInputDto();

    constructor(
        injector: Injector,
        private _profileService: ProfileServiceProxy
    ) {
        super(injector);
    }

    show(): void {
        this.active = true;
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    save(): void {
        this.saving = true;
        this._profileService
            .verifySmsCode(this.verifyCode)
            .finally(() => {
                this.saving = false;
            })
            .subscribe(() => {
                this.close();
                this.modalSave.emit(null);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/profile/sms-verification-modal.component.ts